import {forward} from 'mgrs';
import {toStringHDMS} from 'ol/coordinate';

import i18n from '@explorer/i18n';
import {coordinateSystems} from '@explorer/constants';

const MGRS_POLE_LIMITS = {
  NORTH_DEGREE_LIMIT: 84,
  SOUTH_DEGREE_LIMIT: -80,
};

const getMgrsAccuracy = resolution =>
  5 - resolution.toString().split('.')[0].length + 1; // Max accuracy - resolution magnitude + one-indexed

const formatLocation = (
  location,
  coordSystem = coordinateSystems.dd,
  res = 10000 // default resolution for highest precision
) => {
  if (!location) {
    return location;
  }

  if (coordSystem === coordinateSystems.dms) {
    return toStringHDMS(location);
  }

  if (coordSystem === coordinateSystems.mgrs && res) {
    const accuracy = getMgrsAccuracy(res);
    const lat = location[1];

    // Check to handle MGRS library pole limits
    if (
      lat > MGRS_POLE_LIMITS.NORTH_DEGREE_LIMIT ||
      lat < MGRS_POLE_LIMITS.SOUTH_DEGREE_LIMIT
    ) {
      return '-';
    }

    return forward(location, accuracy);
  }

  const nsCardinal = location[1] > 0 ? 'N' : 'S';
  const ewCardinal = location[0] > 0 ? 'E' : 'W';
  const lat = Math.abs(location[1]).toFixed(5);
  const lon = Math.abs(location[0]).toFixed(5);

  return i18n.t('formatLocation.formatString', {
    nsCardinal,
    ewCardinal,
    lat,
    lon,
  });
};

export default formatLocation;
